/* Global - assets/js
   ---------------------------------------------------------------- */

/**
 * Vanilla JS
 */

/**
 * Loading
 */
window.onload = function() {
	const spinner = document.getElementById( 'loading' );

	function loaded() {
		if ( spinner ) {
			spinner.classList.add( 'loaded' );
		}
	}
	setTimeout( loaded, 240 );
};

/**
 * Scroll → Fade in
 */

// Vertical
const iSObserversFadeInY = document.querySelectorAll( '.u-fade__in-y' );
const optionsFadeInY = {
	rootMargin: '-10% 0px',
};

const fadeInY = ( target ) => {
	target.classList.add( 'u-fade__in-y-on' );
};

const observeUseFadeInY = ( entries ) => {
	entries.forEach( entry => {
		if ( entry.isIntersecting ) {
			fadeInY( entry.target );
		}
	});
};

const observerFadeInY = new IntersectionObserver( observeUseFadeInY, optionsFadeInY );
iSObserversFadeInY.forEach( iSObserverFadeInY => {
	observerFadeInY.observe( iSObserverFadeInY );
});

// Horizontal
const iSObserversFadeInXL = document.querySelectorAll( '.u-fade__in-xl' );
const optionsFadeInXL = {
	rootMargin: '-10% 0px',
};

const fadeInXL = ( target ) => {
	target.classList.add( 'u-fade__in-xl-on' );
};

const observeUseFadeInXL = ( entries ) => {
	entries.forEach( entry => {
		if ( entry.isIntersecting ) {
			fadeInXL( entry.target );
		}
	});
};

const observerFadeInXL = new IntersectionObserver( observeUseFadeInXL, optionsFadeInXL );
iSObserversFadeInXL.forEach( iSObserverFadeInXL => {
	observerFadeInXL.observe( iSObserverFadeInXL );
});

const iSObserversFadeInXR = document.querySelectorAll( '.u-fade__in-xr' );
const optionsFadeInXR = {
	rootMargin: '-10% 0px',
};

const fadeInXR = ( target ) => {
	target.classList.add( 'u-fade__in-xr-on' );
};

const observeUseFadeInXR = ( entries ) => {
	entries.forEach( entry => {
		if ( entry.isIntersecting ) {
			fadeInXR( entry.target );
		}
	});
};

const observerFadeInXR = new IntersectionObserver( observeUseFadeInXR, optionsFadeInXR );
iSObserversFadeInXR.forEach( iSObserverFadeInXR => {
	observerFadeInXR.observe( iSObserverFadeInXR );
});

/**
 * Scroll → Under line
 */

// Vertical
const iSObserversUnderLineY = document.querySelectorAll( '.u-line__under-y' );
const optionsUnderLineY = {
	rootMargin: '-10% 0px',
};

const UnderLineY = ( target ) => {
	target.classList.add( 'u-line__under-y-on' );
};

const observeUseUnderLineY = ( entries ) => {
	entries.forEach( entry => {
		if ( entry.isIntersecting ) {
			UnderLineY( entry.target );
		}
	});
};

const observerUnderLineY = new IntersectionObserver( observeUseUnderLineY, optionsUnderLineY );
iSObserversUnderLineY.forEach( iSObserverUnderLineY => {
	observerUnderLineY.observe( iSObserverUnderLineY );
});

// Horizontal
const iSObserversUnderLineX = document.querySelectorAll( '.u-line__under-x' );
const optionsUnderLineX = {
	rootMargin: '-10% 0px',
};

const UnderLineX = ( target ) => {
	target.classList.add( 'u-line__under-x-on' );
};

const observeUseUnderLineX = ( entries ) => {
	entries.forEach( entry => {
		if ( entry.isIntersecting ) {
			UnderLineX( entry.target );
		}
	});
};

const observerUnderLineX = new IntersectionObserver( observeUseUnderLineX, optionsUnderLineX );
iSObserversUnderLineX.forEach( iSObserverUnderLineX => {
	observerUnderLineX.observe( iSObserverUnderLineX );
});

/**
 * Smooth scroll
 */
const scroll = new SmoothScroll( 'a[href*="#"]', {
	speedAsDuration: true,
	speed: 1200,
	easing: 'easeInOutQuad',
});

/**
 * Smooth scroll BTN hide
 */
const toTopArea = document.querySelector( '#header' );
const toTopBTN = document.getElementById( 'to-top' );

/*toTopBTN.addEventListener( 'click', function() {

	window.scrollTo({
		top: 0,
		behavior: 'smooth',
	});
});*/

const toTopCallback = ( entries ) => {

	if ( entries[0].isIntersecting ) {
		toTopBTN.style.opacity = '0';
		toTopBTN.style.pointerEvents = 'none';

	} else {
		toTopBTN.style.opacity = '1';
		toTopBTN.style.pointerEvents = 'auto';
	}
};

const toTopObserver = new IntersectionObserver( toTopCallback );
toTopObserver.observe( toTopArea );

/**
 * MW WP Formの<form>タグにyubinbango用のh-adrクラスを付ける
 */
const mwWpFormZip = document.querySelector( '.mw_wp_form form' );
if ( mwWpFormZip ) {
	mwWpFormZip.setAttribute( 'class', 'h-adr' );
}

/**
 * jQuery
 */
jQuery( document ).ready( function( $ ) {

});
